import { NgModule } from '@angular/core';

import { BusinessIntelligenceService } from './business-intelligence.service';
import { SharedModule }                from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    BusinessIntelligenceService
  ]
})
export class BusinessIntelligenceModule {}
